var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuizEditIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5719 10.7775L13.5719 9.77754C13.7281 9.62129 14 9.73066 14 9.95566V14.4994C14 15.3275 13.3281 15.9994 12.5 15.9994H1.5C0.671875 15.9994 0 15.3275 0 14.4994V3.49941C0 2.67129 0.671875 1.99941 1.5 1.99941H10.0469C10.2688 1.99941 10.3813 2.26816 10.225 2.42754L9.225 3.42754C9.17813 3.47441 9.11563 3.49941 9.04688 3.49941H1.5V14.4994H12.5V10.9525C12.5 10.8869 12.525 10.8244 12.5719 10.7775ZM17.4656 4.47129L9.25937 12.6775L6.43437 12.99C5.61562 13.0807 4.91875 12.39 5.00938 11.565L5.32188 8.74004L13.5281 0.533789C14.2437 -0.181836 15.4 -0.181836 16.1125 0.533789L17.4625 1.88379C18.1781 2.59941 18.1781 3.75879 17.4656 4.47129ZM14.3781 5.43691L12.5625 3.62129L6.75625 9.43066L6.52812 11.4713L8.56875 11.2432L14.3781 5.43691ZM16.4031 2.94629L15.0531 1.59629C14.925 1.46816 14.7156 1.46816 14.5906 1.59629L13.625 2.56191L15.4406 4.37754L16.4062 3.41191C16.5312 3.28066 16.5312 3.07441 16.4031 2.94629Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuizEditIcon);
export default __webpack_public_path__ + "static/media/quiz-edit-icon.8de8b614b193c69e1a128eed51e5854d.svg";
export { ForwardRef as ReactComponent };